import React from 'react'
import PropTypes from 'prop-types'
import NumberCallout from './number-callout'
import SingleStackedBar from './single-stacked-bar'
import AnimatedNumber from 'react-animated-number'

import { formatValue, clampPercent } from 'state/utils'


class WealthBreakdown extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      totalContributionsTaxable: 0,
      totalContributionsNonTaxable: 0,
      totalTaxable: 0,
      totalNonTaxable: 0,
    }
  }
  componentWillReceiveProps(nextProps){
    if(this.props !== nextProps){
      this.setState({
        totalContributionsTaxable: this.props.totalContributionsTaxable,
        totalContributionsNonTaxable: this.props.totalContributionsNonTaxable,
        totalTaxable: this.props.totalTaxable,
        totalNonTaxable: this.props.totalNonTaxable,
      })
    }
  }
  render() {
    const totalContributions = this.props.totalContributionsTaxable + this.props.totalContributionsNonTaxable
    const totalContributionsOld = this.state.totalContributionsTaxable + this.state.totalContributionsNonTaxable

    const totalReturns = (this.props.totalTaxable + this.props.totalNonTaxable) - totalContributions
    const totalReturnsOld = (this.state.totalTaxable + this.state.totalNonTaxable) - totalContributionsOld

    const clampedPercent = Math.min(Math.max(totalContributions / (totalContributions + totalReturns), 0), 1)
    console.warn((this.props.totalContributionsNonTaxable / (this.props.totalContributionsNonTaxable + this.props.totalContributionsTaxable)) * 100)
    return (
      <div className="WealthBreakdown">

      <div className="WealthBreakdown__section WealthBreakdown__section--overview">
        <NumberCallout
          label="Total contributions"
          value={totalContributions}
          valueOld={totalContributionsOld}
        />
        <NumberCallout
          label="Total returns"
          value={totalReturns}
          valueOld={totalReturnsOld}
        />
      </div>

      <SingleStackedBar percent={clampedPercent} />

      <div className="WealthBreakdown__section">
        <NumberCallout
          label="Total, pre-tax"
          value={this.props.totalNonTaxable}
          valueOld={this.state.totalNonTaxable}
        />
        <NumberCallout
          label="Total, after-tax"
          value={this.props.totalTaxable}
          valueOld={this.state.totalTaxable}
        />
      </div>

      <div className="WealthBreakdown__category_bar">
        <div style={{flex: `0 0 ${clampPercent((this.props.totalContributionsNonTaxable / (this.props.totalContributionsNonTaxable + this.props.totalContributionsTaxable))) * 100}%`}}>
          <SingleStackedBar percent={this.props.totalContributionsNonTaxable / this.props.totalNonTaxable} secondary />
        </div>
        <div style={{flexGrow: 1}}>
          <SingleStackedBar percent={this.props.totalContributionsTaxable / this.props.totalTaxable} secondary />
        </div>
      </div>

      

      <div className="WealthBreakdown__section WealthBreakdown__section--by_category">
        <div className="WealthBreakdown__category">
          <div className="WealthBreakdown__category__row">
            <div className="WealthBreakdown__category__row__label">Contributions</div>
            <div className="WealthBreakdown__category__row__value">
            <AnimatedNumber component="text" 
              value={this.props.totalContributionsNonTaxable}
              initialValue={this.state.totalContributionsNonTaxable}
              style={{
                  transition: '2s ease-out',
                  fontSize: 14,
              }}
              duration={500}
              formatValue={n => formatValue(n)}
              stepPrecision={2}
            />
            </div>
          </div>
          <div className="WealthBreakdown__category__row">
            <div className="WealthBreakdown__category__row__label">Returns</div>
            <div className="WealthBreakdown__category__row__value">
            <AnimatedNumber component="text" 
              value={this.props.totalNonTaxable - this.props.totalContributionsNonTaxable}
              initialValue={this.state.totalNonTaxable - this.state.totalContributionsNonTaxable}
              style={{
                  transition: '2s ease-out',
                  fontSize: 14,
              }}
              duration={500}
              formatValue={n => formatValue(n)}
              stepPrecision={2}
            />
            </div>
          </div>
        </div>
        <div className="WealthBreakdown__category">
          <div className="WealthBreakdown__category__row">
          <div className="WealthBreakdown__category__row__label">Contributions</div>
          <div className="WealthBreakdown__category__row__value">
          <AnimatedNumber component="text" 
              value={this.props.totalContributionsTaxable}
              initialValue={this.state.totalContributionsTaxable}
              style={{
                  transition: '2s ease-out',
                  fontSize: 14,
              }}
              duration={500}
              formatValue={n => formatValue(n)}
              stepPrecision={2}
            />
          </div>
        </div>
        <div className="WealthBreakdown__category__row">
          <div className="WealthBreakdown__category__row__label">Returns</div>
          <div className="WealthBreakdown__category__row__value">
          <AnimatedNumber component="text" 
              value={this.props.totalTaxable - this.props.totalContributionsTaxable}
              initialValue={this.state.totalTaxable - this.state.totalContributionsTaxable}
              style={{
                  transition: '2s ease-out',
                  fontSize: 14,
              }}
              duration={500}
              formatValue={n => formatValue(n)}
              stepPrecision={2}
            />
          </div>
        </div>
        </div>
      </div>

      </div>
    )
  }
}

export default WealthBreakdown


// WEBPACK FOOTER //
// ./sections/wealth-breakdown/wealth-breakdown.js